import { z } from "zod";
import { ValidatorInterface } from "../validator-interface";

export class MinLengthValidator extends ValidatorInterface {
    getZodSchema(baseSchema, options = {}) {
        const minLength = parseInt(options.value, 10);
        const labelText = options.labelText || "This field";
        const message = options.message || `${labelText} must be at least ${minLength} characters`;

        if (isNaN(minLength)) {
            // eslint-disable-next-line no-console
            console.warn("Invalid minLength value provided for MinLengthValidator:", options.value);
            return baseSchema; // Return base schema if minLength is invalid
        }

        // Apply to string schemas
        if (baseSchema instanceof z.ZodString) {
            return baseSchema.min(minLength, { message });
        }
        // Apply to array schemas
        else if (baseSchema instanceof z.ZodArray) {
            // Message might need adjustment for arrays
            const arrayMessage = options.message || `Please select at least ${minLength} item(s)`;
            return baseSchema.min(minLength, { message: arrayMessage });
        }
        // Potentially other types like ZodSet?

        // eslint-disable-next-line no-console
        console.warn("MinLengthValidator applied to unsupported schema type. Requires ZodString or ZodArray.");
        return baseSchema; // Return base schema if type is not supported
    }

    getErrorMessage(field, options = {}) {
        const minLength = parseInt(options.value, 10);
        const labelText = options.labelText || "This field";
        if (isNaN(minLength)) {
            return "Invalid minimum length requirement specified.";
        }
        // Consider field type for message (e.g., input vs select-multiple)
        const fieldType = field?.type;
        if (fieldType === "select-multiple") {
            return options.message || `Please select at least ${minLength} item(s)`;
        }
        return options.message || `${labelText} must be at least ${minLength} characters`;
    }
}
